export default __webpack_public_path__ + "static/media/icon-refresh.dd4042c8.svg";